import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'routes';
import dayjs from 'dayjs';

import { ProBlogPostProps } from 'components/molecules/ProBlogPost';
import { JobType } from 'src/modules/job-types/types';
import { getProLink } from 'utils/marketing-pages';

import styles from './ProBlogPostDetails.module.scss';

interface Props {
  customProfileUrl?: string;
  jobType: JobType;
  post: ProBlogPostProps;
  proDisplayName: string;
  proId: string;
  slug: string;
}

const ProBlogPostDetails: FC<Props> = ({
  customProfileUrl,
  jobType,
  post: { title, htmlContent, createdAt },
  proDisplayName = '',
  proId,
  slug,
}) => {
  const {
    i18n: { language },
    t,
  } = useTranslation();

  const proLink = getProLink({
    customProfileUrl,
    language: language as 'en' | 'ja',
    proId,
    slug,
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const linkPrefix =
    (jobType.categories &&
      `${language === 'en' ? '/en' : ''}/${jobType.categories.join('/')}/${jobType.id}`) ||
    '';

  const postDate = dayjs(createdAt).format('YYYY/MM');
  const sanitizedHtmlContent = htmlContent ?? '';

  return (
    <div className={styles['pro-blog-post-details']}>
      <div className={styles['content']}>
        <section id="content">
          <h3 className={styles['title']}>{title}</h3>
          <p className={styles['name']}>
            <Link prefetch={false} route={proLink}>
              {t('marketingPages:proBlogPostSection.proName', { proDisplayName })}
            </Link>
          </p>
          <div dangerouslySetInnerHTML={{ __html: sanitizedHtmlContent }}></div>
          <p className={styles['name']}>
            <Link prefetch={false} route={linkPrefix}>
              {jobType.translations?.requestType}
            </Link>
            - {postDate}
          </p>
        </section>
      </div>
    </div>
  );
};

export default ProBlogPostDetails;
